{
  "title": "Welcome to $t(common:companyName)!",
  "logo": "$t(common:companyName) + AWS Marketplace",
  "form": {
    "email": "Email Address",
    "name": "Full Name",
    "phone": "Phone Number",
    "optional": "optional",
    "password": "password",
    "signUp": "Sign Up",
    "agreement": "By creating an account with $t(common:companyName) you are agreeing to our <a href='https://$t(common:defaultHost)/terms-of-service/' target='_blank'>terms of service</a>."
  },
  "existingAccountTitle": "Existing Account",
  "existingAccountDescription": "Log in to your existing $t(common:companyName) account to link your AWS Marketplace subscription.",
  "logIn": "Log In",
  "signUp": "Or sign up with",
  "signInWith": "Sign in with {{ service }}"
}
